import React from 'react'
import './Part3.css'

function Part3() {
    return (
        <div className="part3">

            <a href="https://apple.com" className="part3-card">
                {/* <img className="part3-card-pic" src="files/img/Annotation 2021-10-26 123126.png" alt="" /> */}
                <div className="part3-card-txt">
                    <p>fbg</p>
                </div>
            </a>

        </div>
    )
}

export default Part3



// WEBPACK FOOTER //
// ./src/components/Part3/Part3.js